module.exports = __webpack_public_path__ + "img/960.fd562cf4.svg";